<div class="pdf-container">
    <mat-card-header class="page-header">
      <h2>{{data.fileName}}</h2>
      <tpa-button [config]="closeButton"></tpa-button>
    </mat-card-header>
    @if(data.jsonObject){
    <mat-card-content class="p-0">
      <div class="json-view">
        <ngx-json-viewer [json]="data.jsonObject"></ngx-json-viewer>
      </div>
    </mat-card-content>
    }
    @else {
    <mat-card-content class="p-0" [ngClass]="data.mimeType.startsWith('image/') ? 'viewer-content' : 'pdf-content'">
        @if(data.mimeType.startsWith('image/')) {
        <img [src]="safeUrl" alt="Preview" class="image" />
        }
        @else {
          @if(data.mimeType === 'application/pdf') {
          <div class="pdf-controls">
            <tpa-button [config]="zoomInButton"></tpa-button>
          <tpa-button [config]="zoomOutButton"></tpa-button>
          </div>
          <pdf-viewer [src]="pdfSrc" [zoom]="zoom" [show-all]="true"  class="pdf-viewer"></pdf-viewer>
          }
          @else {
            <p>{{'PREAUTH.PREAUTH_REQUEST.ATTACHMENTS.VIEW_NOT_SUPPORTED' | translate}}</p>
          }
        }
    </mat-card-content>
    }
    @if(data.jsonObject) {
    <mat-dialog-actions align="end">
      <div class="row mb-0 search-input-row justify-content-end btn-grps-p-24">
        <div class="col-auto">
          <tpa-button [config]="copyJsonButtonConfig"></tpa-button>
        </div>
      </div>
    </mat-dialog-actions>
    }
</div>